import { render, staticRenderFns } from "./LoanPerformanceMineDetail.vue?vue&type=template&id=cfb97e96&scoped=true&"
import script from "./LoanPerformanceMineDetail.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceMineDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanPerformanceMineDetail.vue?vue&type=style&index=0&id=cfb97e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb97e96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VFlex})
